const definedFields = (row) => Object.fromEntries(Object.entries(row).filter(([, value]) => value !== undefined && value !== null));
function mergeRows(lists, idFields) {
    const rows = new Map();
    lists.forEach((list, listIndex) => {
        (Array.isArray(list) ? list : []).forEach((row, index) => {
            if (!row || typeof row !== 'object')
                return;
            const id = idFields.map(field => row[field]).find(value => value !== null && value !== undefined && value !== '');
            const key = id === undefined ? `anonymous:${listIndex}:${index}` : String(id);
            rows.set(key, { ...rows.get(key), ...definedFields(row) });
        });
    });
    return [...rows.values()];
}
/** Shared responses repeat items as list summaries and full map records.
 * Merge child records by ID instead of letting a summary discard coordinates.
 */
export function mergeSharedRouteItems(...lists) {
    const items = new Map();
    lists.forEach((list, listIndex) => {
        (Array.isArray(list) ? list : []).forEach((item, index) => {
            var _a, _b, _c;
            if (!item || typeof item !== 'object')
                return;
            const id = (_b = (_a = item.item_travel_id) !== null && _a !== void 0 ? _a : item.id) !== null && _b !== void 0 ? _b : item.item_id;
            const key = id === undefined || id === null || id === '' ? `anonymous:${listIndex}:${index}` : String(id);
            const previous = items.get(key) || {};
            items.set(key, {
                ...previous, ...definedFields(item),
                points: mergeRows([previous.points, item.points], ['point_travel_id', 'id', 'point_id']),
                tracks: mergeRows([previous.tracks, item.tracks], ['travel_plan_geo_id', 'id']),
                params: ((_c = item.params) === null || _c === void 0 ? void 0 : _c.length) ? item.params : previous.params || [],
            });
        });
    });
    return [...items.values()];
}
